import HttpClientToken from '../../services/HttpClientToken';

import { AsentamientoParser, AsentamientoProps, defaultAsentamiento, ObtenerCodigosPostalesParams } from '../../interfaces/catalogos/AsentamientoInterface';

export const ObtenerCodigosPostales = ( idMunicipio: number ) => {

    return new Promise<ObtenerCodigosPostalesParams[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Asentamiento/ObtenerCodigosPostales/${ idMunicipio }`, token)
            .then( ({ data } : { data : ObtenerCodigosPostalesParams[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerAsentamientos = ( param: AsentamientoProps ) => {

    return new Promise<AsentamientoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Asentamiento/ObtenerAsentamientos/', param, token)
            .then( ({ data } : { data : AsentamientoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerAsentamientosMunicipio = ( id: number ) => {

    return new Promise<AsentamientoParser[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Asentamiento/ObtenerAsentamientosMunicipio/${id}`, token)
            .then( ({ data } : { data : AsentamientoParser[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const Asentamientos = () => {

    return new Promise<AsentamientoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Asentamiento/', token)
            .then( ({ data } : { data : AsentamientoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarAsentamiento = ( params: AsentamientoProps ) => {

    return new Promise<AsentamientoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Asentamiento/Actualizar', params, token)
            .then( ({ data } : { data : AsentamientoProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultAsentamiento } );
            });

        }

    });

}

export const AgregarAsentamiento = ( params: AsentamientoProps ) => {

    return new Promise<AsentamientoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Asentamiento/Agregar', params, token)
            .then( ({ data } : { data : AsentamientoProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultAsentamiento } );
            });

        }

    });

}
